import React, {
    useCallback,
    useEffect,
    useMemo
} from 'react';
import { useSelector } from 'react-redux';

import { ComboboxSelector } from '../screens/Visits/EnrollVisit/ComboboxSelector';
import { getUserInfo } from '../selectors/getters';
import { parseToDdMmYyyy } from '../utils';
import { selectOptions } from './Modal';

const getNameFunction = (item) => {
    const bd = item?.birthday ? ` (${parseToDdMmYyyy(item.birthday)})` : '';
    if (item?.fullNameRu) {
        return `${item?.fullNameRu}${bd}`;
    } else if (item?.name) {
        return `${item?.name}${bd}`;
    }
    console.log('getNameFunction', { item });
    return item?.isMe ? Object.R('titles.myProfile') : '';
};

const getProfileHint = (profile) => {
    if (!profile) {
        return '-';
    }
    if (profile.isMe) {
        return Object.R('titles.for_me');
    }
    const bd = profile?.birthday ? ` (${parseToDdMmYyyy(profile.birthday)})` : '';
    const name = profile?.fullNameRu || profile?.name || profile?.subName;
    return `${name}${bd}`;
};

export const LightProfileSelector = ({
    selectedProfile,
    onSelect,
    enabled = true,
    filterByAccessLevel = null,
    isLoading = false,
    sectionStyle: customSectionStyle = { marginTop: 14 },
    isError = false,
}) => {
    const userInfo = useSelector(getUserInfo);
    const relatives = userInfo?.relatives || [];

    // Формируем массив профилей: главный профиль + родственники
    const profiles = useMemo(() => {
        const mainProfile = userInfo ? {
            ...userInfo,
            isMe: true,
            id: userInfo.profileId || userInfo.me?.profileId || 'me',
            originalName: userInfo.name,
        } : null;

        const allProfiles = [];

        if (mainProfile) {
            // Добавляем name через getNameFunction
            mainProfile.name = getNameFunction(mainProfile);
            allProfiles.push(mainProfile);
        }

        // Фильтрация родственников
        const filteredRelatives = relatives.filter((relative) => {
            // Если указан уровень доступа для фильтрации
            if (filterByAccessLevel) {
                return relative.accessLevels?.includes(filterByAccessLevel);
            }
            // По умолчанию оставляем только детей
            return relative.isChild;
        });

        const relativesWithNames = filteredRelatives.map((relative) => ({
            ...relative,
            name: getNameFunction(relative),
        }));

        allProfiles.push(...relativesWithNames);

        return allProfiles;
    }, [ userInfo,
        relatives,
        filterByAccessLevel ]);

    // Преселект главного профиля по умолчанию
    useEffect(() => {
        if (!selectedProfile && profiles.length > 0) {
            onSelect(profiles[0]);
        }
    }, [ profiles,
        selectedProfile,
        onSelect ]);

    const onPressHandler = useCallback(() => {
        selectOptions({
            title: 'titles.select_profile',
            data: profiles?.map?.((p = {}) => ({
                ...p,
                id: p?.profileId || p?.userId,
            })),
            selected: selectedProfile?.id,
            onSelect: (item) => {
                onSelect(item);
            },
            getName: getNameFunction,
        });
    }, [ selectedProfile,
        profiles,
        onSelect ]);

    // Если только один профиль, отключаем возможность выбора
    const isEnabled = enabled && profiles.length > 1;

    return (
        <ComboboxSelector
            title=""
            value={selectedProfile?.name}
            enabled={isEnabled}
            onPressHandler={onPressHandler}
            containerStyle={{
                marginTop: 0,
                marginBottom: 0,
            }}
            // isLoading={isLoading}
            // isError={isError}
        />
    );
};
